import {AxiosError} from 'axios';
import {useQuery} from 'react-query';
import {toast} from 'react-toastify';
import {getPersianErrorCode} from '../../../global/helpers/ErrorCodes/ErrorCode';
import {getOrderOtpCode} from './getOrderOtpCode';

export interface ErrorResponse {
  error_code?: string;
  message?: string;
}

const useGetOrderOtpCode = (handleSuccess?: (message: string) => void) => {
  const {data, isLoading, refetch, isFetching} = useQuery(
    ['get-order-otp-code'],
    getOrderOtpCode,
    {
      enabled: false,

      onSuccess: data => {
        handleSuccess?.(data?.message);
      },

      onError: (error: AxiosError<ErrorResponse>) => {
        const errorMessage = error.response?.data?.message;
        const errorCode = error.response?.data?.error_code;

        if (errorMessage) toast.error(errorMessage);

        if (errorCode) toast.error(getPersianErrorCode(errorCode));
      },
    },
  );

  return {
    data,
    isLoading,
    refetch,
    isFetching,
  };
};

export default useGetOrderOtpCode;
